<template>
  <b-modal id="modal-add-edit-mesa-votacion" size="md" :no-close-on-backdrop="true" :no-close-on-esc="true" v-model="mostrarModal" dialog-class="modal-dialog-scrollable" v-if="mostrarModal" @close="handleModalClose">
    <template slot="modal-title">
      <div>
        <span class="font-weight-light"><i class="la la-table"></i> {{ mesaVotacion.localVotacionMesaId ? "Editar" : "Agregar" }} Mesa de Votación</span>
      </div>
    </template>
    <b-form id="frm-add-edit-mesa-votacion">
      <div class="row pt-1">
        <div class="col-md-12">
          <label class="font-weight-bold">Local de votación</label>
          <treeselect :multiple="false" :options="localesVotacionOptions" placeholder="Buscar local de votación..." v-model="mesaVotacion.localVotacionId"></treeselect>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">N° de Mesa</label>
          <b-form-input v-model="mesaVotacion.mesa" required placeholder="Número de mesa"></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Electores</label>
          <b-form-input v-model="mesaVotacion.electores" type="number" placeholder="Cantidad de electores"></b-form-input>
        </div>
      </div>
    </b-form>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="handleModalClose()"><i class="fa fa-ban"></i> Cancelar</button>
      <button type="button" class="btn btn-primary font-weight-bold" @click.prevent="doSave()"><i class="fa fa-save"></i> Guardar</button>
    </template>
  </b-modal>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "add-edit-mesa-votacion",
  props: {
    value: { type: Boolean, required: true },
    mesaVotacionId: { type: Number },
  },
  data: () => ({
    mostrarModal: true,
    localesVotacionOptions: [],
    mesaVotacion: {
      localVotacionMesaId: null,
      localVotacionId: null,
      mesa: "",
      electores: null,
      usuarioAsignadoId: 0,
    },
  }),
  methods: {
    handleModalClose(event) {
      if (event) event.preventDefault();
      this.mostrarModal = false;
    },
    async doSave() {
      if (!(await this.sweetConfirm("¿Desea guardar los datos?"))) return;
      if (!this.mesaVotacion.localVotacionId) return this.sweetAlert("Debe seleccionar el local de votación.");
      if (!this.isFormValid("frm-add-edit-mesa-votacion")) return this.sweetAlert("Hay campos con valores incorrectos. Revise los datos ingresados.");

      var model = { ...this.mesaVotacion };
      await this.$http.post(this.apiRoute("Location", "AddEditMesaVotacion"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.sweetAlert(response.body.message, "success");
          this.$emit("onSave", { localVotacionMesaId: response.body.data.localVotacionMesaId });
        }
      }, this.mostrarMensajeExcepcionVueResource);
      this.mostrarModal = false;
    },
    fetchMesaVotacion(mesaVotacionId) {
      if (mesaVotacionId) {
        this.$http.get(this.apiRoute("Location", "GetMesaVotacionById"), { params: { LocalVotacionMesaId: mesaVotacionId } }).then(function(response) {
          this.mesaVotacion = response.body.data;
        });
      } else {
        this.mesaVotacion = {
          localVotacionMesaId: null,
          localVotacionId: null,
          mesa: "",
          electores: null,
          usuarioAsignadoId: 0,
        };
      }
    },
    fetchLocalesVotacion() {
      var model = { pagination: { paginate: false } };
      this.$http.post(this.apiRoute("Location", "ListLocalesVotacion"), model).then(function(response) {
        var items = response.body.data.items || [];
        this.localesVotacionOptions = items.map(function(x) {
          var label = [x.codigo, x.nombre, x.direccion].filter(Boolean).join(" - ");
          return { id: x.localVotacionId, label: label || "Sin descripción" };
        });
      }, this.mostrarMensajeExcepcionVueResource);
    },
  },
  watch: {
    mostrarModal(newValue) { this.$emit("input", newValue); },
  },
  mounted() {
    this.mostrarModal = this.value;
    this.mesaVotacion.localVotacionMesaId = this.mesaVotacionId;
    this.initParsley();
    this.fetchLocalesVotacion();
    this.fetchMesaVotacion(this.mesaVotacionId);
  },
};
</script>
